import { render, staticRenderFns } from "./BookmakerOddsButton.vue?vue&type=template&id=fcbf3bda"
import script from "./BookmakerOddsButton.vue?vue&type=script&lang=js"
export * from "./BookmakerOddsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports